// extracted by mini-css-extract-plugin
module.exports = {"container":"_1UqbvhpiTLMUpyMpG70ciw","admin":"_3d8ejWLBslwqL44ie3Wr6Y _1UqbvhpiTLMUpyMpG70ciw","date":"_1pvtGO0rV9pDYX6MiGhHgq","text":"ylF9ln4ta07HyRL7IaiyZ"};